/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
/* eslint-disable @typescript-eslint/no-unsafe-return */
/* eslint-disable @typescript-eslint/no-unsafe-member-access */
/* eslint-disable @typescript-eslint/no-explicit-any */

// Import 3rd-party dependencies
import { OnInit } from '@angular/core';

// Import project-specific dependencies
import { AnalyticsModule } from '@app/core/analytics/analytics.module';
import { InsightsService, IClickEventData } from '@app/core/analytics/services/app-insights-service';

type fnType = (...args: unknown[]) => unknown;

export const TrackedPage = (pageName: string) => (ctor: OnInit | any): void => {
  const ngOnInit = ctor.prototype.ngOnInit as fnType;

  ctor.prototype.ngOnInit = function (...args: unknown[]) {
    const injector = AnalyticsModule.injector;

    if (injector) {
      const analyticsService = injector.get(InsightsService);
      analyticsService.trackPageView(pageName);
    } else {
      console.warn('Analytics module was not bootstrapped.');
    }

    ngOnInit && ngOnInit.apply(this, args);
  };
};

export const TrackedEvent = (event: IClickEventData) => (
  target: any,
  propertyKey: string,
  descriptor: PropertyDescriptor
): PropertyDescriptor => {
  const originalMethod = descriptor.value as fnType;

  descriptor.value = function (...args: unknown[]) {
    const injector = AnalyticsModule.injector;
    if (injector) {
      const analyticsService = injector.get(InsightsService);
      analyticsService.trackClickEvent(event);
    } else {
      console.warn('Analytics module was not bootstrapped.');
    }

    originalMethod && originalMethod.apply(this, args);
  };
  return descriptor;
};
